export default function (alertify) {
  'ngInject';

  alertify.logPosition('bottom right');
}
